import { createAction, props } from '@ngrx/store';
import { MembershipEntity } from '@resident-select/domain/membership';

export const GotMembershipByResidentEvent = createAction(
  'GotMembershipByResidentEvent',
  props<{ entities: MembershipEntity[] }>()
);

export const GotAllMembershipsEvent = createAction(
  'GotAllMembershipsEvent',
  props<{ entities: MembershipEntity[] }>()
);

export const CanceledMembershipEvent = createAction(
  'CanceledMembershipEvent',
  props<{ entities: MembershipEntity[] }>()
);
